module.exports = __webpack_public_path__ + "img/bg_image_1.b9ce0f02.png";